import { SignatureCustomer } from "./SignatureCustomer";
import { SignatureStore } from "./SignatureStore";

export const Signature = {
  Customer: SignatureCustomer,
  Store: SignatureStore,
}
